import api from "./index";

export type PatientTimelineEventType =
  | "EXAM_ADDED"
  | "TREATMENT_ADDED"
  | "APPOINTMENT_CREATED"
  | "APPOINTMENT_MISSED"
  | "PAYMENT_ADDED";

export interface PatientTimelineItem {
  id?: string;
  patientId: string;
  eventType: PatientTimelineEventType;
  refId?: string | null;
  doctorId: string;
  meta?: any;
  createdOn?: string;
}

export const PatientTimelineService = {
  getByPatientId: async (patientId: string) => {
    return api.get(`/patient-timeline/getByPatientId/${patientId}`);
  },
};

export default PatientTimelineService;


